export default {
  // Hero section
  'hero.title': '专业在线计时工具',
  'hero.subtitle': '为您的需求选择完美的计时工具',
  
  // Tool cards
  'timer.title': '计时器',
  'timer.description': '工作、学习和生活的倒计时器',
  'timer.longDescription': '用于提高工作效率、烹饪和时间管理的倒计时器',
  'timer.button': '启动计时器',
  
  'stopwatch.title': '秒表',
  'stopwatch.description': '高精度计时工具',
  'stopwatch.longDescription': '用于运动、训练和精确计时的高精度秒表',
  'stopwatch.button': '启动秒表',
  
  'worldclock.title': '世界时钟',
  'worldclock.description': '查看全球时区',
  'worldclock.longDescription': '实时显示全球主要城市时间，智能时区计算',
  'worldclock.button': '查看世界时钟',
  
  // Features section
  'features.title': '为什么选择 timer.today？',
  'features.reliable.title': '可靠精确',
  'features.reliable.desc': '毫秒级精度计时，基于浏览器的可靠性',
  'features.crossPlatform.title': '跨平台',
  'features.crossPlatform.desc': '在桌面、平板和移动设备上完美运行',
  'features.smartNotifications.title': '智能通知',
  'features.smartNotifications.desc': '时间到时提供声音提醒和桌面通知',
  'features.easyToUse.title': '易于使用',
  'features.easyToUse.desc': '简洁界面，所有用户都能直观操作',
  
  // Keywords section
  'keywords.timer': '计时器 倒计时 番茄钟 专注 工作 休息',
  'keywords.english': 'timer countdown pomodoro focus work break',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};